<template>
  <b-modal ref="modal" id="session-expired-modal" hide-header centered @show="onShow" @hide="onHide">
    <div class="msg">
      <p id="session-expired-message" v-html="$t('YOUR_SESSION_HAS_EXPIRED')" />
    </div>

    <div slot="modal-footer">
      <primary-button @click="off" v-bind:text="$t('LOG_IN')" />
    </div>
  </b-modal>
</template>

<script>
import { watch } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import PrimaryButton from '@/components/PrimaryButton';
import { PATHS } from '@/consts';

const { useGetters, useActions } = createNamespacedHelpers('modal');
const { useActions: useUserActions } = createNamespacedHelpers('user');

export default {
  name: 'SessionExpiredModal',
  components: {
    PrimaryButton
  },
  setup(props, { refs, root: { $router } }) {
    const { isSessionExpiredModalActive: isOpen } = useGetters(['isSessionExpiredModalActive']);
    const { toggleSessionExpiredModal: toggle } = useActions(['toggleSessionExpiredModal']);
    const { logout } = useUserActions(['logout']);

    const off = () => {
      refs.modal.hide();
    };

    const onShow = () => {
      logout();

      const { resolved } = $router.resolve(window.location.pathname);
      if (resolved.path !== PATHS.LOGIN) {
        $router.push(PATHS.LOGIN);
      }
    };

    const onHide = () => {
      toggle(false);
    };

    watch(isOpen, (newVal) => {
      const { modal } = refs;

      if (newVal) modal.show();
      else modal.hide();
    });

    return {
      isOpen,
      off,
      onShow,
      onHide
    };
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

#session-expired-modal {
  .modal-body {
    padding-top: 30px;
    padding-bottom: 20px;
  }

  .msg {
    p {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
}
</style>
